import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresAgregarVincular', {
    template: template,
    controller: NominasNominaColaboradoresAgregarVincularComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      desconocidos: '<',
      empleados: '<',
      onCancel: '&',
      onChange: '&',
    },
  })

function NominasNominaColaboradoresAgregarVincularComponent(NominasNominaMovimientosEmpleados, NominasNominaEmpresasasociadas) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.cancelar = cancelar
  $ctrl.importar = importar
  $ctrl.validar = validar
  $ctrl.vincular = vincular

  function $onInit() {
    $ctrl.data = null
    $ctrl.error = null
    $ctrl.alertas = null
    $ctrl.buscar = $ctrl.desconocidos
      .filter(function (item) {
        return item['empleado']
      })
      .map(function (item) {
        return {
          query: item['empleado'],
          data: item,
        }
      })

    $ctrl.promise = NominasNominaEmpresasasociadas.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.empresas = response.data
      })
  }

  function cancelar() {
    $ctrl.onCancel()
  }

  function importar() {
    return NominasNominaMovimientosEmpleados.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.validos = []
        $ctrl.invalidos = []
        $ctrl.error = null
        $ctrl.alertas = []

        $ctrl.data.forEach(function (item) {
          let desconocido = item.data,
            empleado = response.data.find(function (empleado) {
              return empleado.id_empresa === item.seleccion.id_empresa
                && empleado.id_empleado === item.seleccion.id_empleado
            })

          if (empleado)
            $ctrl.validos.push(angular.merge({}, desconocido, empleado))
          else
            $ctrl.invalidos.push(item.seleccion)
        })

        if (!$ctrl.invalidos.length)
          vincular()
      })
  }

  function validar($event) {
    $ctrl.data = null
    $ctrl.error = null
    $ctrl.alertas = []

    if (!$event.data)
      return

    if (!$event.data.length)
      cancelar()

    let index = [],
      data = []

    $event.data.forEach(function (item) {
      if (item.seleccion) {
        let alerta = 'DUPLICADO - El empleado ' + item.seleccion.empleado + ' se encuentra duplicado. Los importes se sumarán.'
        if (index.indexOf(item.seleccion.empleado) >= 0 && $ctrl.alertas.indexOf(alerta) < 0)
          $ctrl.alertas.push(alerta)

        index.push(item.seleccion.empleado)
      }
    })

    $event.data.forEach(function (item) {
      if (!item.seleccion) {
        $ctrl.alertas.push('OMITIR - Se omitirá el registro ' + item.query)
      } else if (item.seleccion && !item.seleccion.activo) {
        $ctrl.alertas.push('INACTIVO - El empleado ' + item.seleccion.empleado + ' está inactivo.')
        data.push(item)
      } else {
        data.push(item)
      }
    })

    $ctrl.alertas = $ctrl.alertas.sort()

    $ctrl.data = data
  }

  function vincular() {
    if ($ctrl.validos.length)
      $ctrl.onChange({$event: {data: $ctrl.validos}})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/agregar/vincular/component.js